// extracted by mini-css-extract-plugin
export default {"secondary-column-cell":"secondary-column-cell_f73Vu","secondaryColumnCell":"secondary-column-cell_f73Vu","lds-ring":"lds-ring_ebcUD","ldsRing":"lds-ring_ebcUD"};